import { styled } from '@mui/material/styles';
import { Tabs } from '@mui/material'
import { Box } from '@mui/system'
import HourAvailable from './HourAvailable'
import { useRecoilState } from 'recoil';
import { showModalReservationState, hourSelectedState , professionalSelectedState } from 'src/store/reservation/reservationState';


const StyledTabs = styled((props) => <Tabs {...props} />)(
    ({ theme }) => ({
        width: '100%',
        '& .MuiTabs-scrollButtons': {
            display: 'inherit',
        },
        '.Mui-disabled': {
            display: 'none'
        },
        '.MuiButtonBase-root': {
            opacity: 1,
            minWidth: 72,
        },
    }),
);


const ListHoursAvailables = ({ professional }) => {

    const [, setShowModal] = useRecoilState(showModalReservationState);
    const [, setHourSelected] = useRecoilState(hourSelectedState);
    const [, setProfessionalSelected] = useRecoilState(professionalSelectedState);
    
    const handleClickOpenModalReservation = (el) => ev => {
        console.log("Abrir modal IMG => ", el)
        setHourSelected(el);
        setProfessionalSelected(el)
        setShowModal(true);
    }

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
        }}>
            <StyledTabs
                value={false}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="styled tabs example"
            >
                {
                    professional.horas.map((el) => (
                        <HourAvailable
                            click={handleClickOpenModalReservation({ professional, hourSelected: el })}
                            key={`${el.ageCorrel}_${el.ageInicio}`}
                            hour={el.ageInicio}
                        />
                    ))
                }
            </StyledTabs>
        </Box>
    )
}

export default ListHoursAvailables
